import OrderAppConfig from './order/ordersAppConfig';
import CommercialProposalAppConfig from './commercial-proposal/commercialProposalAppConfig';

const SalesAgentAppConfig = [OrderAppConfig, CommercialProposalAppConfig];

export default SalesAgentAppConfig;
